import { type DropzoneOptions, useDropzone } from 'react-dropzone';

import { BaseTooltip } from '../BaseTooltip';
import { Container, DropzoneMessage } from './styles';

export type FileDropzoneProps = DropzoneOptions & {
  maxFilesLimit?: number;
};

export const FileDropzone = ({
  maxFilesLimit,
  ...dropzoneProps
}: FileDropzoneProps): JSX.Element => {
  const isMaxReached =
    typeof dropzoneProps.maxFiles === 'number' && dropzoneProps.maxFiles <= 0;
  const dropzoneDisabled = dropzoneProps.disabled === true || isMaxReached;

  const { getRootProps, getInputProps, isFocused, isDragAccept, isDragReject } =
    useDropzone({
      ...dropzoneProps,
      disabled: dropzoneDisabled,
    });

  const tooltipMessage =
    maxFilesLimit !== undefined
      ? `Maximum number of ${maxFilesLimit} files reached`
      : 'Maximum number of files reached';

  return (
    <BaseTooltip
      message={tooltipMessage}
      disabled={!isMaxReached}
      dataCy="file-dropzone-max-files-tooltip"
    >
      <Container
        {...getRootProps({ isFocused, isDragAccept, isDragReject })}
        isDisabled={dropzoneDisabled}
      >
        <input {...getInputProps()} />
        <DropzoneMessage>
          Drag and Drop or <span>Browse</span> to upload
        </DropzoneMessage>
      </Container>
    </BaseTooltip>
  );
};
